export default {
  ambitusDetector: {
    back: 'Back',
    introduction: 'Introduction',
    determineRange: 'Let\'s determine your vocal range',
    testDescription: 'We\'re going to test your voice range together - it will be quick and painless! 😉',
    testInstructions: 'The piano will gradually play increasingly low notes, then increasingly high notes. Try to sing along with them.',
    increaseVolumeTitle: 'Turn up the volume',
    increaseVolumeText: 'This exercise requires your device\'s sound to be turned on.',
    warmUpTitle: 'Remember to warm up',
    warmUpText: 'To make sure you\'re in the best conditions, don\'t hesitate to warm up your voice a bit before starting the exercise.',
    takeTest: 'Take the Test',
    notInterested: 'I\'m not interested in singing',
    startingNote: 'Starting Note',
    startingNoteCaption: 'Choosing the starting note',
    findIdealNote: 'Let\'s find the ideal note to start the test!',
    areYou: 'Are you...',
    genderInfo: 'This information helps us choose the best starting note to maximize the accuracy of this test. This information will not be saved.',
    man: 'A Man',
    woman: 'A Woman',
    other: 'Other',
    noAnswer: 'prefer not to answer',
    lowMeasure: 'Low Measurement',
    lowMeasureCaption: 'Measuring the lowest singable note',
    findLowestNote: 'Let\'s find your lowest note',
    highMeasure: 'High Measurement',
    highMeasureCaption: 'Measuring the highest singable note',
    findHighestNote: 'Let\'s do the same to find your highest note',
    validation: 'Validation',
    congratsMessage: 'Congratulations, what a voice! Thanks to this little exercise, we\'ll be able to adapt the songs in our repertoire to your voice.'
  },
  ambitusValidation: {
    rangeDescription: 'Here is your entire vocal range, the range of notes you can sing.',
    tooBigWarning: 'Your vocal range spans more than 3 octaves which is generally not possible.',
    tooBigAdvice: 'we strongly recommend that you <b>retake the test</b> paying attention to the limit zones (the lowest or highest notes).',
    noForcing: '<b>You should not strain your voice too much!</b>',
    veryBigWarning: 'Your vocal range seems very wide, it\'s not impossible but quite rare!',
    veryBigAdvice: 'we recommend that you <b>check your vocal range</b> especially <b>in the limit zones</b> (the lowest or highest notes).',
    retakeTest: 'Retake the Test',
    loading: 'Loading...',
    confirm: 'Confirm',
    changeNote: 'Change the note: ',
    low: 'low',
    high: 'high'
  },
  noteEvaluator: {
    start: 'Start',
    canSingQuestion: 'Can you sing this note naturally?',
    canSing: 'I can sing it',
    tooComplicated: 'Note Too Difficult',
    foundNote: 'We found your {direction} note!',
    high: 'highest',
    low: 'lowest',
    confirmAbility: 'Are you really able to sing this note?',
    confirmChoice: 'I confirm',
    restartStep: 'Restart this step',
    sureQuestion: 'Are you sure of your choice?',
    imSure: 'I\'m sure',
    restart: 'I\'ll start over'
  }
};